export default "__VITE_ASSET__B8IL11P3__"